

import * as yup from 'yup';
import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';


/**
 * /tantu/list.php 页面用户信息
 *
 * @export
 * @param {object} [params=goodsList._definedParams]
 * @returns
 */
export async function goodsList(params = goodsList._definedParams) {
  const api = 'api/v1.14/Poi/Mobile/UserStatusAndTopic';
  params = ensureParams(params, goodsList._definedParams);

  const data = await apiProxy.post(api, params);

  return data.UserStatusAndTopic.data;
}

goodsList._definedParams = {
  flashSaleHash: '',
  edmType: '',
  edmUserId: '',
  edmAddTime: '',
  poiSource: ''
};

/**
 * 用户目标城市（订单、IP）
 *
 * @export
 * @returns
 */
export async function goalCity() {
  const api = 'api/v1.16/Poi/Mobile/FindUserCity';
  const dataSchema = yup.object().shape({
    FindUserCity_v1_16: yup.object().shape({
      data: yup.object().shape({
        order_city_id: yup.number().required(),
        location_city_id: yup.number().required()
      })
    })
  });

  const data = await apiProxy.post(api, {}, { dataSchema });

  return data.FindUserCity_v1_16.data;
}

customizedTourUserInfo._definedParams = {
  destination: '',
  name: '',
  code: '',
  phone: ''
};

/**
 * 定制游用户信息收集
 *
 * @export
 * @returns
 */
export async function customizedTourUserInfo(params = customizedTourUserInfo._definedParams) {
  const api = 'api/v1.20/Poi/CustomizedTour';
  const data = await apiProxy.post(api, params);

  return data.poi_group__Poi_CustomizedTour_v1_20.data;
}


/**
 *  获取用户常用预订人信息
 */
export async function getBookerList() {
  const api = 'api/v1.0/Poi/User/BookerInfo';
  const dataSchema = yup.object().shape({
    getBookerInfo: yup.object().shape({
      data: yup.array(
        yup.object().shape({
          username: yup.string().required(),
          email: yup.string(),
          phone: yup.object().shape({
            code: yup.number().required(),
            phone: yup.number().required()
          }).required(),
          deliveryArea: yup.string(),
          deliveryAddress: yup.string()
        })
      )
    }).required()
  });
  const data = await apiProxy.get(api, { dataSchema });

  return data.getBookerInfo.data;
}


/**
 * 获取规格出行人列表（关联预定信息）
 * option-traveler 对象是经过数据校验的，结构与 traveler 结构不同
 * @param {*} param0
 */
export async function getOptionTravelerList({ goodsId, packageId, optionId }) {
  const api = 'api/v1.0/Poi/User/Traveler/TravelerList';
  const dataSchema = yup.object().shape({
    getUserTravelerList: yup.object().shape({
      data: yup.array(
        yup.object().shape({
          id: yup.number().required(),
          name: yup.string() // 数据上会有空字符的情况，直接报错又不好
        })
      )
    }).required()
  });
  const data = await apiProxy.get(api, {
    params: { goodsId, packageId, optionId },
    dataSchema
  });

  return data.getUserTravelerList.data;
}

/**
 * 创建出行人（关联预定信息）
 * @param {*} traveler
 * @param {*} param1
 */
export async function postTravelerForOption(traveler, { goodsId, packageId, optionId }) {
  traveler = { ...traveler, id: 0 };
  return await putTravelerForOption(traveler, { goodsId, packageId, optionId });
}

/**
 * 更新出行人（关联预定信息）
 * @param {*} traveler
 * @param {*} param1
 */
export async function putTravelerForOption(traveler, { goodsId, packageId, optionId }) {
  const api = 'api/v1.0/Poi/User/Traveler/CreateOrUpdate';
  // createOrUpdateUserTraveler
  const dataSchema = yup.object().shape({
    createOrUpdateUserTraveler: yup.object().shape({
      data: yup.object({
        id: yup.number().required()
      })
    }).required()
  });
  const data = await apiProxy.post(api, {
    traveler,
    goodsId,
    packageId,
    optionId
  }, { dataSchema });

  return data.createOrUpdateUserTraveler.data;
}


/**
 * 获取被保人列表
 */
export async function getPiccUserList() {
  const api = 'api/v1.0/Poi/User/Insurance/PiccUserList';
  const dataSchema = yup.object().shape({
    getPiccUserList: yup.object().shape({
      data: yup.array(
        yup.object().shape({
          id: yup.number().required(),
          username: yup.string().required()
        })
      )
    }).required()
  });
  const data = await apiProxy.get(api, { dataSchema });

  return data.getPiccUserList.data;
}

/**
 * 更新picc用户
 * @param {object} piccUser
 */
export async function putPiccUser(piccUser) {
  const api = 'api/v1.0/Poi/User/Insurance/CreateOrUpdatePiccUser';
  // todo dataSchema
  const data = await apiProxy.post(api, piccUser);

  return data.createOrUpdatePiccUser.data;
}

/**
 * 创建picc用户
 * @param {object} piccUser
 */
export async function postPiccUser(piccUser) {
  return await putPiccUser(piccUser);
}
